module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAAAXNSR0IB2cksfwAAAGlQTFRFAAAA8gAA+AAA/wAA/gAA/wAA/AAA/wAA/wAA7wAA/QAA+gAA/wAA/AAA/wAA/gAA/wAA/QAA/wAA/wAA/gAA/gAA/AAA/wAA/gAA/gAA/QAA/gAA+QAA/wAA/AAA/QAA/QAA/QAA/wAACKGIQgAAACN0Uk5TABMk77r/WRDnEJU2/V8EzkBwHPKtrEsK396HvSv6YJd0cymG3sydAAAAhUlEQVR4nGXN2RKCMBBE0WZpRNYACsqq/P9HmkhiDLkPqZlTqRrAFATwCqMo9DAm47MllCWuXVKF6dXBjN+yf8sLsizJIrdW1fKXEPKpqx82NMjGWNtZ7FqNN1rk/bD+uKwOqXplw4NOz0HiqJdp0sMIzIue11UPy4yNXhtePr6BXZza8QHUSggy1UfM/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/reports-active.png
// module id = 289
// module chunks = 33